let service = function () {
	"ngInject";
};

export default service;


// WEBPACK FOOTER //
// ./app/components/statistics/statistics.service.js